/* eslint-disable */
/* tslint:disable */

import request, { ContentType, RequestParams } from './httpClient'
import { WebResp } from './types'

export interface DomainMQLPaymentRequest {
  order_id?: string
  payment_method?: string
  requested_at?: number
}

export interface DomainMQLFollowupItem {
  id?: number
  user_id?: number
  name?: string
  email?: string
  order_ids?: string[]
  order_codes?: string[]
  payment_requests?: DomainMQLPaymentRequest[]
  status?: string
  first_sent_at?: number
  first_result?: string
  second_sent_at?: number
  second_result?: string
  reply?: string
  reply_at?: number
  stop_auto?: boolean
  created_at?: number
  updated_at?: number
}

export interface DomainMQLFollowupEmailItem {
  id?: string
  direction?: string
  subject?: string
  from_address?: string
  to_addresses?: string[]
  status?: string
  error_message?: string
  occurred_at?: number
  body_preview?: string
}

export interface DomainMQLFollowupEmailListResp {
  data?: DomainMQLFollowupEmailItem[]
}

export interface DomainMQLFollowupListResp {
  data?: DomainMQLFollowupItem[]
  has_next_page?: boolean
  total_count?: number
}

export interface GetAdminMQLFollowupListParams {
  page?: number
  size?: number
  status?: string
  has_unknown?: boolean
  keyword?: string
  start_at?: number
  end_at?: number
  stop_auto?: boolean
  last_result?: string
}

export interface DomainMQLFollowupReplyReq {
  reply: string
}

export const getAdminMQLFollowupList = (query: GetAdminMQLFollowupListParams, params: RequestParams = {}) =>
  request<WebResp & { data?: DomainMQLFollowupListResp }>({
    path: `/api/v1/admin/mql-followups`,
    method: 'GET',
    query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

export const postAdminMQLFollowupReply = (id: number, body: DomainMQLFollowupReplyReq, params: RequestParams = {}) =>
  request<WebResp & { data?: unknown }>({
    path: `/api/v1/admin/mql-followups/${id}/reply`,
    method: 'POST',
    body,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

export const postAdminMQLFollowupStop = (id: number, params: RequestParams = {}) =>
  request<WebResp & { data?: unknown }>({
    path: `/api/v1/admin/mql-followups/${id}/stop`,
    method: 'POST',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

export const postAdminMQLFollowupPaid = (id: number, params: RequestParams = {}) =>
  request<WebResp & { data?: unknown }>({
    path: `/api/v1/admin/mql-followups/${id}/paid`,
    method: 'POST',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

export const getAdminMQLFollowupEmails = (id: number, params: RequestParams = {}) =>
  request<WebResp & { data?: DomainMQLFollowupEmailListResp }>({
    path: `/api/v1/admin/mql-followups/${id}/emails`,
    method: 'GET',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
